export default "__VITE_ASSET__Cf7vL4fX__"